<template>
  <Container type="card-full">
    <div class="search">
      <div class="search_box">
        <div class="searchItem">
          <div class="label">项目编号</div>
          <div class="field">
            <el-input v-model.trim="query.projectcode" clearable></el-input>
          </div>
        </div>
        <div class="searchItem">
          <div class="label">项目名称</div>
          <div class="field">
            <el-input v-model.trim="query.projectname" clearable></el-input>
          </div>
        </div>
        <div class="searchItem">
          <div class="label">状态</div>
          <div class="field">
            <el-select v-model="query.status" :clearable="true" placeholder="请选择">
              <el-option v-for="item in projectStatusList" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="searchItem">
          <div class="search_btn">
            <el-button @click="search">查询</el-button>
          </div>
        </div>
      </div>
    </div>
    <vggrid :list="list" tableheight="600" flexname="" :cols="cols" :showfooter="false" :showPage="true"
      :resizable="true" :total="query.total" @cellClick="cellClick" @cellDblClick="viewProject" @pagechange="pagechange"
      :isOperate="btn.isOperate" :operateBtn="btn.right" @vggridClick="vggridClick">
      <template slot="btn">
        <menu-btn :menuid="menuid" @btnClick="btnClick" @btnmenuclick="btnmenuclick"></menu-btn>
      </template>
    </vggrid>
  </Container>
</template>
<script>
import request from '@/utils/request'
import MenuBtn from "../common/menuBtn"
import vggrid from '../common/vggrid'
import utils from '../../assets/js/utils'
export default {
  name: 'projectIndex',
  data() {
    return {
      menuid: this.$route.query.menuid,
      list: [],
      btn: {},
      btnLoading: false,
      cols: [
        { type: 'index', fieldtype: 'I', title: '行号', calculExpr: '', width: 80 },
        { field: 'projectcode', fieldtype: 'C', title: '项目编号', calculExpr: '', addNewRowFlg: false },
        { field: 'projectno', fieldtype: 'C', title: '平台编号', calculExpr: '', addNewRowFlg: false },
        { field: 'projectname', fieldtype: 'C', title: '项目名称', calculExpr: '', addNewRowFlg: false },
        // { field: 'projectdesc', fieldtype: 'C', title: '采购内容',calculExpr:'',addNewRowFlg: false},
        { field: 'projectstatusname', fieldtype: 'C', title: '状态', calculExpr: '', addNewRowFlg: false },
        { field: 'projectrecusername', fieldtype: 'C', title: '创建人', calculExpr: '', addNewRowFlg: false },
        { field: 'projecttime', fieldtype: 'T', title: '创建时间', calculExpr: '', addNewRowFlg: false, formatter: ['toDateString', ''] }
      ],
      project: {},
      projectStatusList: [],
      query: {
        cosid: this.$store.getters.loginUser.cosid,
        userid: this.$store.getters.loginUser.userid,
        comid: this.$store.getters.loginUser.comid,
        comtype: this.$store.getters.loginUser.comtype,
        projecttype: '2',
        total: 0,
        limit: 20,
        offset: 0
      }
    }
  },
  created() {
    this.$on('ADD', () => this.addProject())
    this.$on('CHG', () => this.chgProject())
    this.$on('DEL', () => this.delProject())
    this.$on('SETPM', () => this.setPm())
    this.$on('SETRULE', () => this.setRule())
    this.$on('BATCHPSU', () => this.batchPsu())
    this.$on('INVITEPSU', () => this.invatedCom())
    this.$on('SETPG', () => this.setPg())
    this.$on('PEXPERT', () => this.pexpert())
    this.$on('FBXMGG', () => this.projectNotice())
    this.$on('BGGG', () => this.projectChangeNotice())
    this.$on('CQGG', () => this.projectClarificationNotice())
    this.$on('ZZGG', () => this.projectTerminationNotice())
    this.$on('FBGG', () => this.projectBulletinNotice())
    this.$on('CLOSE', () => this.close())
  },
  activated() {
    this.init()
    this.getPageList()
    this.getProjectStatusList()
  },
  mounted() {
  },
  watch: {
  },
  components: { MenuBtn, vggrid },
  methods: {
    async getProjectStatusList() {
      this.projectStatusList = await request({
        url: '/kfgl/syscode/getSysCodeList',
        method: "get",
        params: { syscode: 'projectstatus' }
      })
    },
    btnClick(code) {
      this.$emit(code)
    },
    vggridClick(code, row) {
      this.project = row
      this.$emit(code, row)
    },
    btnmenuclick(btn) {
      this.btn = btn
    },
    async init() {
      this.query = {
        cosid: this.$store.getters.loginUser.cosid,
        userid: this.$store.getters.loginUser.userid,
        comid: this.$store.getters.loginUser.comid,
        comtype: this.$store.getters.loginUser.comtype,
        projecttype: '2',
        total: 0,
        limit: 20,
        offset: 0
      }
      this.list = []
      this.btnLoading = false
      this.project = {}
    },
    async close() {
      this.$store.commit('close_tab', { routeName: this.$route.name, vm: this, newRouteName: '' })
    },
    async projectChangeNotice() {
      this.projectAnnouncement('变更公告', 60)
    },
    async projectClarificationNotice() {
      this.projectAnnouncement('澄清公告', 70)
    },
    async projectTerminationNotice() {
      this.projectAnnouncement('终止公告', 80)
    },
    async projectBulletinNotice() {
      this.projectAnnouncement('采购失败公告', 90)
    },
    async projectAnnouncement(name, wmenudatawhere) {
      if (!this.project.projectid) {
        this.$message.warning('请选择一个项目!')
        return
      }
      let wmenu = await request({
        method: 'get',
        url: '/ywgl/wmenu/getWmenuId',
        params: { wmenudatawhere: wmenudatawhere }
      })
      let form = {
        project: this.project,
        noticefromid: this.project.projectid,
        wmenuid: wmenu[0].wmenuid,
        wmenuname: name,
        wmenudatawhere: wmenudatawhere
      }
      this.$router.push({ name: 'pjnoticeIndex', params: { form: form } })
    },
    async projectNotice() {
      if (!this.project.projectid) {
        this.$message.warning('请选择一个项目!')
        return
      }
      if (!this.project.prsbmbegtime) {
        this.$message.warning('请设置项目规则!')
        setTimeout(() => {
          this.$router.push({ name: 'prsForm', params: { form: this.project, type: 1 } })
        }, 900)
        return
      }

      let pmmxList = await request({
        method: 'get',
        url: '/xmgl/project/getPmmxList',
        params: { projectid: this.project.projectid }
      })
      if (!pmmxList.length) {
        this.$message.warning('请设置品目信息!')
        setTimeout(() => {
          this.$router.push({ name: 'pmmxIndex', params: { form: this.project } })
        }, 900)
        return
      }
      let pgList = await request({
        metho: 'get',
        url: '/xmgl/project/getPgList',
        params: { projectid: this.project.projectid }
      })
      if (!pgList.length) {
        this.$message.warning('请设置评分项目!')
        setTimeout(() => {
          this.$router.push({ name: 'pgIndex', params: { form: this.project, type: 1 } })
        }, 900)
        return
      }
      let pexpertList = await request({
        url: '/xmgl/project/getPexpertList',
        method: "get",
        params: { projectid: this.project.projectid }
      })

      let psuList = await request({
        method: 'get',
        url: '/xmgl/project/getPsuListByProjectId',
        params: { projectid: this.project.projectid, type: 1, comid: this.$store.getters.loginUser.comid }
      })
      if (Number(this.project.projectisinvite) === 1 && !psuList.length) {
        this.$message.warning('请邀请供应商!')
        setTimeout(() => {
          this.$router.push({ name: 'pInviteForm', params: { form: this.project, type: 1 } })
        }, 900)
        return
      }
      let nowdate = await request({
        method: 'get',
        url: 'xtgl/sysdata'
      })
      if (new Date(this.project.prsbmendtime).getTime() <= new Date(nowdate).getTime()) {
        this.$message.warning('该项目报名已结束，请重新设置项目规则!')
        setTimeout(() => {
          this.$router.push({ name: 'prsForm', params: { form: this.project, type: 1 } })
        }, 900)
        return
      }

      // this.$router.push({name: 'projectResultNotice', params: {projectid:this.project.projectid}})
      this.$router.push({ name: 'projectNotice', params: { projectid: this.project.projectid, type: 1 } })
    },
    async batchPsu() {
      if (!this.project.projectid) {
        this.$message.warning('请选择一个项目!')
        return
      }
      this.$router.push({ name: 'psuBatchForm', params: { form: this.project, type: 1 } })
    },

    async invatedCom() {
      if (!this.project.projectid) {
        this.$message.warning('请选择一个项目!')
        return
      }
      if (Number(this.project.projectisinvite) !== 1) {
        this.$message.warning('邀请类项目才能邀请供应商')
        return
      }

      this.$router.push({ name: 'pInviteForm', params: { form: this.project, type: 1 } })
    },
    async setPg() {
      if (!this.project.projectid) {
        this.$message.warning('请选择一个项目!')
        return
      }
      this.$router.push({ name: 'pgIndex', params: { form: this.project, type: 1 } })
    },
    async viewProject(row) {
      this.project = row.row
      this.$router.push({ name: 'projectView', params: { form: this.project, innerbtn: this.btn.inner, type: 1 } })
    },
    async addProject() {
      let form = {
        projectid: 0,
        projecttype: '2',
        cosid: this.$store.getters.loginUser.cosid,
        projectacomid: null,
        projectauserid: null,
        projectatel: null,
        projectpcomid: null,
        projectpuserid: null,
        projectptel: null,
        projectlimitamt: null,
        projectbmamt: null,
        projectbzjamt: null
      }
      this.$router.push({ name: 'projectForm', params: { form: form, type: 1 } })
    },
    async chgProject() {
      if (!this.project.projectid) {
        this.$message.warning('请选择一个项目!')
        return
      }
      if (this.project.projectstatus !== '10') {
        this.$message.error('项目公告已发布，不能修改！')
        return
      }
      this.$router.push({ name: 'projectForm', params: { form: this.project, type: 2 } })
    },
    async setPm() {
      if (!this.project.projectid) {
        this.$message.warning('请选择一个项目!')
        return
      }
      this.$router.push({ name: 'pmmxIndex', params: { form: this.project } })
    },
    async setRule() {
      if (!this.project.projectid) {
        this.$message.warning('请选择一个项目!')
        return
      }
      this.$router.push({ name: 'prsForm', params: { form: this.project, type: 1 } })
    },
    async pexpert() {
      if (!this.project.projectid) {
        this.$message.warning('请选择一个项目!')
        return
      }
      switch (this.project.projectstatus) {
        case 10:
          this.$message.error('项目还未发布，不能抽取评审人！')
          return
        case 40:
          this.$message.error('项目已完成，不能抽取评审人！')
          return
        case 50:
          this.$message.error('项目已归档，不能抽取评审人！')
          return
      }
      if (this.project.projectdoneflg === '1') {
        this.$message.error('价格定标法，不需要抽取评审人评分')
        return
      }
      this.$router.push({ name: 'pexpertForm', params: { form: this.project, type: 2 } })
    },
    async delProject() {
      if (!this.project.projectid) {
        this.$message.warning('请选择一个项目!')
        return
      }
      if (this.project.projectstatus !== '10') {
        this.$message.error('项目公告已发布，不能删除！')
        return
      }
      this.$confirm('确定删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        let data = await request({
          url: '/xmgl/project/delProject',
          method: "post",
          data: this.project
        })
        if (data.issuccess === 1) {
          this.getPageList()
          this.$message.success('删除成功！')
        } else {
          this.$message.error(data.msg)
        }
      })
    },
    async cellClick(row) {
      this.project = row.row
    },
    async pagechange(page) {
      this.query.offset = page.pageSize * (page.currentPage - 1)
      this.query.limit = page.pageSize
      this.getPageList()
    },
    search() {
      this.query.offset = 0
      this.getPageList()
    },
    async getPageList() {
      console.log(this.query)
      this.loading = true
      let res = await request({
        method: 'get',
        url: '/xmgl/project/getPageList',
        params: this.query
      })
      console.log(res)
      this.list = res.list
      this.query.total = res.count[0].count
      this.loading = false
    }
  },
  filters: {
  }
}
</script>
<style lang="scss">

</style>
